<template>
    <div class="modal fade" id="modal-drivers-sms" ref="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" :class="{'modal-with-preview': preview}">
            <div class="modal-content modal-lg">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                    <h4 class="modal-title">
                        Bericht aan {{ selectedUsers }} chauffeur<span v-if="selectedUsers !== 1">s</span>
                    </h4>
                </div>

                <div class="modal-body">
                    <p><label>Type bericht</label></p>
                    <app-button-group
                        class="m-bottom-15"
                        v-model="type"
                        type="radio"
                        :data="types"
                        @click="textAreaInput">
                    </app-button-group>

                    <div v-if="type === 'free'" class="m-top-20">
                        <p><label>Kies een script</label></p>
                        <select class="form-control" v-model="script" :disabled="Boolean(send)">
                            <option v-for="smsScript in scripts" v-if="smsScript.content" :value="smsScript.content" :selected="script === smsScript.content">{{ smsScript.title }}</option>
                        </select>
                    </div>

                    <p class="m-top-20"><label>Bericht</label></p>
                    <div v-if="type === 'free'">
                        <div class="labels">
                            <span
                                class="badge badge-label badge-secondary cursor-pointer"
                                v-for="placeholder in smsPlaceholders"
                                @click="insertPlaceholder(placeholder)"
                            >
                                {{ placeholder.name }} <i class="fa fa-plus"></i>
                            </span>
                        </div>
                    </div>
                    <textarea-counter
                        ref="textarea"
                        :value="sms"
                        :disabled="disabled"
                        :max="200"
                        :show-counter="false"
                        classNames="form-control form-control-gray"
                        @input="textAreaInput"
                    ></textarea-counter>

                    <div class="alert alert-warning" v-if="usersNotAvailable.length > 0 && type === 'availability'" style="margin-top: 15px;">
                      Let op! Er {{ usersNotAvailable.length === 1 ? 'is' : 'zijn' }} {{ usersNotAvailable.length }} chauffeur{{ usersNotAvailable.length === 1 ? '' : 's' }}
                      geselecteerd die geen beschikbaarheid {{ usersNotAvailable.length === 1 ? 'heeft' : 'hebben' }} opgegeven voor deze datum.
                      Deze chauffeur{{ usersNotAvailable.length === 1 ? '' : 's' }} {{ usersNotAvailable.length === 1 ? 'zal' : 'zullen' }} geen melding ontvangen.
                    </div>
                </div>



                <!-- Modal Actions -->
                <div class="modal-footer text-left">
                    <button type="button" class="btn btn-md btn-primary" :disabled="Boolean(send)" @click="send = 1">
                        <span><i class="fa fa-send"></i> Bericht verzenden</span>
                    </button>

                    <button type="button" class="btn btn-md btn-secondary pull-right" @click="preview = !preview">
                        <span v-if="preview"><i class="fa fa-mobile-phone"></i> Voorbeeld sluiten</span>
                        <span v-else><i class="fa fa-mobile-phone"></i> Voorbeeld</span>
                    </button>

                    <div class="row m-top-30" v-if="send">
                        <div class="col-sm-12">
                            <p><strong>Weet je zeker dat je het bericht wilt verzenden?</strong></p>
                            <button type="button" class="btn btn-md btn-primary" @click="sendSMs" :disabled="sending">
                                <span v-if="sending === false">Bericht verzenden</span>
                                <span v-else><i class="fa fa-spin fa-circle-o-notch"></i> Bezig met versturen</span>
                            </button>
                            <button type="button" class="btn btn-md btn-secondary" @click="send = 0" v-if="sending === false">
                                <span>Nee wijzig bericht</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-preview">
                <div class="modal-preview-dialog">
                    <div class="dialog-box p-bottom-10">
                        <div class="background-blur"></div>
                        <div class="header">
                            <div class="contents">
                                <div class="left">
                                    <img src="/images/appicon.png">
                                    <span class="app-name">AutoAfleveren.nl</span>
                                </div>
                                <div class="right">
                                    Nu
                                </div>
                            </div>
                        </div>
                        <div class="contents main-content pull-left" style="padding-left:0px; padding-right: 0px; padding-bottom: 0px;">
                          <div style="padding: 0px 5px;">
                            <strong style="white-space: pre-line; letter-spacing: .1px;">{{ smsTitle }}</strong>
                          </div>

                          <div v-html="smsPreview" class="truncate-overflow" style="padding:0px 5px; white-space: pre-line; letter-spacing: .1px; overflow:hidden;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AppButtonGroup from '../AppButtonGroup.vue';
    export default {
        name: 'SmsModal',
      components: {AppButtonGroup},
      props: {
            scripts: {
                type: Object,
                required: true
            },
            placeholders: {
                type: Array,
                required: true,
            },
            users: {
              type: Array,
              default: []
            },
            usersNotAvailable: {
              type: Array,
              default: []
            },
            date: {
                type: String,
                default: null
            }
        },

        data() {
            return {
                type: 'free',
                message: null,
                script: null,
                send: false,
                sending: false,
                preview: false,
                smsContent: '',
                smsTitle: '',
            }
        },
        mounted() {
            this.script = _.values(this.scripts)[1].content;

            jQuery(this.$refs.modal).modal().on('hidden.bs.modal', () => {
              this.$emit('close');
            });

            if (this.availabilityDisabled === false && this.date) {
                this.type = 'availability';
            }
        },

        computed: {
            types() {
              if (this.availabilityDisabled) {
                return [
                  {
                    title: 'Vrije invulling',
                    value: 'free'
                  }
                ]
              }

              return [
                  {
                    title: 'Beschikbaarheid',
                    value: 'availability'
                  },
                  {
                    title: 'Vrije invulling',
                    value: 'free'
                  }
              ]
            },
            selectedUsers() {
                return this.users.length;
            },
            availabilityDisabled() {
                if (this.date === null) {
                  return true;
                }

                if (this.send) {
                  return true;
                }

                return this.usersNotAvailable.length === this.users.length;
            },
            sms() {
               if (this.type === 'availability') {
                   return _.values(this.scripts)[0];
               }

               return this.script;
            },

            disabled() {
                if (this.type === 'availability') {
                    return true;
                }

                return Boolean(this.send)
            },

            smsPlaceholders() {
                return this.placeholders.filter((placeholder) => {
                    return (placeholder.visibleOnDate && this.date) || ! placeholder.visibleOnDate
                });
            },

            smsPreview() {
                return this.smsContent;
            }
        },

        methods: {
            textAreaInput(value) {
                const data = {
                    type: this.type,
                    date: moment(this.date).format('DD-MM-YYYY'),
                    users: this.users,
                    message: this.$refs.textarea.textareaModel
                }
                this.$http.post(`/chauffeurs/preview-sms`, data).then(function(response) {
                    this.smsTitle = response.data.title;
                    this.smsContent = response.data.content.replace(/\n/g, "<br />");
                });
            },
            sendSMs() {
                this.sending = true;
                const data = {
                    type: this.type,
                    date: moment(this.date).format('DD-MM-YYYY'),
                    users: this.users,
                    message: this.$refs.textarea.textareaModel
                }
                this.$http.post(`/chauffeurs/send-sms`, data).then(function(response) {
                    this.send = false;
                    this.sending = false;

                    notify('Notificatie verstuurd', 'success');

                    this.$emit('sended', this.type, data);
                }, function (response) {
                    this.send = false;
                    this.sending = false;

                    notify('We konden de notificatie niet versturen', 'danger');
                });
            },

            insertPlaceholder(placeholder) {
                this.$refs.textarea.insert(placeholder.value);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/drivers/SmsModal.vue